import React, { memo, useContext, useEffect, useReducer } from 'react';
import './css/HomePage1ArticlesCarousel1.css';
import { useSnackbar } from 'notistack';
import { Carousel } from 'react-responsive-carousel';
import { context } from '../../../../../../globalState/GlobalState';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { fetchLimitedArticlesAPI } from '../../../../../apiCalls/ArticleAPICalls';
import ArticleThumbnail5 from '../../../../../uiElements/articleThumbnails/articleThumbnail5/ArticleThumbnail5';

const initialState = {
    articles: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchArticles':
            return { ...state, articles: action.articles };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const HomePage1ArticlesCarousel1 = () => {
    const { globalState } = useContext(context);
    const [state, setState] = useReducer(reducer, initialState);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchArticles() {
            setState({ type: 'setLoadingSpinner', loadingSpinner: true });
            await fetchLimitedArticlesAPI(globalState.accountId, 3, setState, enqueueSnackbar);
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetchArticles();
    }, []);

    return (
        <div className="homepage1-articles-carousel1-container bg-white">
            <Carousel className="homepage1-articles-carousel1" showThumbs={false} autoPlay dynamicHeight={false} interval={14000} transitionTime={500} infiniteLoop showIndicators showStatus={false}>
                {
                    state.articles.map((article) => {
                        return (
                            <React.Fragment key={article.id}>
                                <ArticleThumbnail5 article={article} />
                            </React.Fragment>
                        );
                    })
                }
            </Carousel>
        </div>
    );
};

export default memo(HomePage1ArticlesCarousel1);
